import * as utils from '../styleUtils';

const { makeASlightlyDifferentColor } = utils;

export default function (designSettings = {}) {
    const { dashboards = {} } = designSettings;
    const {
        navTextColor,
        navBackgroundColor,
        navHoverBackgroundColor,
        navTextHoverColor,
    } = dashboards;

    return {
        '.navver-host, .navver-host a': {
            color: navTextColor,
        },
        '.navver-host': {
            backgroundColor: navBackgroundColor,
        },
        [`.navver-host .list-item:hover,
        .navver-host .list-item--selected`]: {
            backgroundColor: navHoverBackgroundColor,
            color: navTextHoverColor,
        },
        [`.navver-host .slf-navver-icon,
        .navver-host .slf-navver-icon-hov,
        .navver-host .navver-dashboards-search-input label`]: {
            color: navTextColor,
        },
        '.btn.slf-navver-icon-hov:hover': {
            color: navTextColor,
            backgroundColor: makeASlightlyDifferentColor(navBackgroundColor),
        },
        '.btn.slf-navver-icon:hover': {
            color: navTextColor,
            backgroundColor: 'transparent',
        },
        '.btn.slf-navver-icon-hov[disabled=disabled]:hover': {
            color: navTextColor,
            backgroundColor: 'transparent',
        },
        '.btn.slf-navver-icon[disabled=disabled]:hover': {
            color: navTextColor,
            backgroundColor: 'transparent',
        },
        [`.navver-host .list-item:hover .slf-navver-icon,
         .navver-host .list-item--selected .slf-navver-icon
        `]: {
            color: navTextHoverColor,
        },
    };
}
